export const languageElements = {
    items: {
      "form-title": {
        hu: "CUSTOMER PORTAL REGISZTRÁCIÓ",
        de: "CUSTOMER PORTAL REGISTRIERUNG",
        en: "CUSTOMER PORTAL REGISTRATION",
      },
  
       "field-Email": {
        hu: "Email",
        de: "Email",
        en: "Email",
      },
      "field-Name": {
        hu: "Felhasználónév",
        de: "Benutzername",
        en: "Username",
      },
      "field-TermsAndConditionsAccepted-before": {
        hu: "Elfogadom a",
        de: "Ich akzeptiere die ",
        en: "I accept the",
      },
      "field-TermsAndConditionsAccepted-link": {
        hu: "felhasználási feltételeket",
        de: "Nutzungsbedingungen",
        en: "terms of use",
      },
      "field-TermsAndConditionsAccepted-after": {
        hu: "",
        de: "",
        en: "",
      },
      "field-Password": {
        hu: "Jelszó",
        de: "Passwort",
        en: "Password",
      },
      "field-PasswordAgain": {
        hu: "Jelszó ismét",
        de: "Passwort erneut",
        en: "Password again",
      },
      "btn-submit": {
        hu: "Mentés",
        de: "Speichern",
        en: "Save",
      },
      "MESSAGE_USER_ALREADY_EXISTS-title": {
        hu: "Ezzel az e-mail címmel már van felhasználó a customer portal-on",
        de: "Diese E-Mail-Adresse existiert bereits im Customer Portal",
        en: "This e-mail address already exists on the customer portal",
      },
      "MESSAGE_DATA_SUCCESSFULLY_SAVED-title": {
        hu: "A módosított adatokat elmentettük",
        de: "Die geänderten Daten wurden gespeichert",
        en: "The modified data has been saved",
      },
      "validate-password-and-passwordAgain-not-match": {
        hu: "Nem egyezik meg a jelszóval",
        de: "Stimmt nicht mit Passwort überein",
        en: "Does not match password",
      },
      "validate-password-not-complex-enough": {
        hu: "A jelszó legyen legalább 8 karakter, legyen benne kis- és nagybetű",
        de: "Das Passwort muss mindestens 8 Zeichen lang sein und sowohl Groß- als auch Kleinbuchstaben enthalten.",
        en: "The password must be at least 8 characters long and contain both uppercase and lowercase letters.",
      },
    },
  };
  